import resonance_img from './images/resonance.png'
import noiseimage_img from './images/test-image2.png'
import passivesurfacewave_img from './images/passivesurfacewave.png'
import ftresonance_img from './images/ftresonance.jpg'
import activesurfacewave_img from './images/activesurfacewave.png'
import reflect_img from './images/reflect.png'
import tomoimage from './images/00df85dbeb262485530ccac063c10f6.png'
import tomoimage1 from './images/tomoimage1.png'
import spacmaster_img from './images/spacmaster.png'
import magnic2 from './images/magnic2.png'


import newresonance_img from './newimg/newresonance_img.png';
import newresonance1 from './newimg/newresonance1.png';
import newresonance3 from './newimg/resonance3.png';
import newpassivewave2d from './newimg/passivewave2d.png';
import newactivesurfacewave from './newimg/activesurfacewave.png';
import newfmodeling from './newimg/fmodeling.png';
import newmigrationt from './newimg/migrationt.png';
import newtwostation2d from './newimg/twostation2d.png'
import newtomoimage from './newimg/tomoimage.png'
import newrtcomputingsw from './newimg/rtcomputingsw.png'
import newrtcomputingpl from './newimg/rtcomputingpl.png'
import newftresonance from './newimg/ftresonance.png'
import newrtresonance from './newimg/rtresonance.png'


const modulesConfig = {
    TECHNIC_PREFIX: {
        resonance: "PSFI",
        resonance1: "PSFJ",
        noiseimage: "PSNI",
        reflect: 'RSFI',
        passivesurfacewave: "SWIP",
        activesurfacewave: "ASWI",
        // dataprocess: "MMPD",
        spacmaster: "SPAC",
        magnetic: "MGDP",
        rtcompute: 'RTSW',
        diffraction: 'DWES',
        ewave2d: 'ES2D',
        rtcomputingsw: 'RTSW',
        // 震源追踪
        rtcomputingpl: 'RTPL',
        // 实时计算频域成像
        ftresonance: 'FTPS',
        // 频率成像实时计算
        rtresonance: 'RTPS',
        awave2d: 'AC2D',
        fmodeling: 'FMDE',
        // 二维常规偏移
        migrationt: 'MIGT',
        // 二维层析成像
        tomoimage: 'TOMO',
        // 起浮地表二维偏移
        surmigrationt: 'MIGN',
        // 浅层反射
        shreflect: 'SHRE',
        passivewave2d: 'SWIT',
        twostation3d: 'DP3D',
        surwavetomo: 'ADPT',
        pwaveswib2d: 'SWIB',


        twostation2d: 'DP2D',
        resonance3: 'PSFK',
        twostation2dmid: 'DP2E',
        passivewave31: 'SWIE',

    },
    PROGRESS_IMAGE_CONFIG: {
        geology: {

        },
        seismic: {
            resonance: newresonance_img,
            resonance1: newresonance1,
            noiseimage: noiseimage_img,
            passivesurfacewave: passivesurfacewave_img,
            activesurfacewave: newactivesurfacewave,
            reflect: reflect_img,
            shreflect: reflect_img,
            passivewave2d: newpassivewave2d,
            twostation3d: reflect_img,

            twostation2d: newtwostation2d,
            resonance3: newresonance3,
            twostation2dmid: newtwostation2d,

            surwavetomo: reflect_img,
            pwaveswib2d: reflect_img,
            spacmaster: spacmaster_img,
            diffraction: reflect_img,
            ewave2d: reflect_img,
            rtcomputingsw: newrtcomputingsw,
            // 震源追踪
            rtcomputingpl: newrtcomputingpl,
            // 实时计算频域成像
            ftresonance: newftresonance,
            // 频率成像实时计算
            rtresonance: newrtresonance,
            awave2d: passivesurfacewave_img,
            fmodeling: newfmodeling,
            // 二维常规偏移
            migrationt: newmigrationt,
            // 二维层析成像
            tomoimage: newtomoimage,
            surmigrationt: reflect_img,
            passivewave31: passivesurfacewave_img,

        },
        well: {

        },
        electricity: {

        },
        magnetism: {
            magnetic: magnic2
        },
        gravity: {

        },
        remotesense: {

        },
        geochemical: {

        }
    },
    TECHNOLOGY: {
        seismic: {
            // seismic: "seismic",
            resonance: "resonance",
            resonance1: "resonance1",
            resonance3: 'resonance3',
            // noiseimage: "noiseimage",
            passivesurfacewave: "passivesurfacewave",
            passivewave31: 'passivewave31',
            passivewave2d: 'passivesurfacewave',

            activesurfacewave: "activesurfacewave",
            // reflect: "reflect",
            // spacmaster: 'spacmaster',
            // diffraction: 'diffraction',
            //    2022-12-1 韩知笑  去掉二维弹性波正演模拟和二维声波正演模拟
            // ewave2d: 'ewave2d',
            // awave2d: 'awave2d',
            fmodeling: 'fmodeling',
            migrationt: 'migrationt',

            // 起浮地表二维偏移
            surmigrationt: 'surmigrationt',

            tomoimage: 'tomoimage',


            //浅层反射
            // shreflect: 'shreflect',
            // twostation3d: 'passivewave2d',

            // surwavetomo: 'passivewave2d',
            // pwaveswib2d: 'passivewave2d',

            // twostation2d: 'passivewave2d',

            twostation2dmid: 'twostation2dmid',


        },
        geology: {
            // geology: "geology"
        },
        well: {
            // well: "well"
        },
        electricity: {
            // electricity: "electricity"
        },
        magnetism: {
            // magnetism: "magnetism"
            magnetic: "magnetic"
        },
        gravity: {
            // gravity: "gravity"
        },
        remotesense: {
            // remotesense: "remotesense"
        },
        geochemical: {
            // geochemical: "geochemical"
        }
    },
    SPECIALITY: {
        seismic: "seismic",
        geology: "geology",
        well: "well",
        electricity: "electricity",
        magnetism: "magnetism",
        gravity: "gravity",
        remotesense: "remotesense",
        geochemical: "geochemical"
    },
    RT_TECHNOLOGY: {
        seismic: {
            rtcomputingsw: 'rtcomputingsw',
            // 震源追踪
            rtcomputingpl: 'rtcomputingpl',
            // 实时计算频域成像
            ftresonance: 'ftresonance',
            // 实时计算频域成像
            rtresonance: 'rtresonance',
        },
    }
}

export default modulesConfig
